import { render, staticRenderFns } from "./EntityDetailJSONDiff.view.vue?vue&type=template&id=18bd0452&"
import script from "./EntityDetailJSONDiff.view.vue?vue&type=script&lang=ts&"
export * from "./EntityDetailJSONDiff.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports